"use client";
import { GNB } from "@/components/gnb";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import React from "react";

export default function DashboardLayout({
  children,
  main,
  sidebar,
}: {
  children: React.ReactNode;
  main: React.ReactNode;
  sidebar: React.ReactNode;
}) {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background">
        <GNB />
        <div className="flex min-h-screen">
          {sidebar}
          <main className="flex-1 min-h-screen bg-background">
            {main || children}
          </main>
        </div>
        <Toaster />
      </div>
    </ThemeProvider>
  );
}
